const UPDATE_INFO = 'actualizacion-de-datos';
const UPDATE_INFO_CONTRACT = 'contrato';

export const UPDATE_INFO_ROUTES = {

    UPDATE_INFO,
    UPDATE_INFO_CONTRACT,

    ROUTE_INFO: `${UPDATE_INFO}`,
    ROUTE_INFO_CONTRACT: `${UPDATE_INFO}/${UPDATE_INFO_CONTRACT}`,
}

